import { visit as e } from "unist-util-visit";
import { toString as r } from "hast-util-to-string";
import { filter as t } from "unist-util-filter";
import n from "parse-numeric-range";
import { refractor as i } from "refractor/lib/common.js";
import { refractor as o } from "refractor/lib/all.js";

function a() {
  a = function a(e, r) {
    return new t(e, void 0, r);
  };

  var e = RegExp.prototype,
      r = new WeakMap();

  function t(e, n, i) {
    var o = new RegExp(e, n);
    return r.set(o, i || r.get(e)), l(o, t.prototype);
  }

  function n(e, t) {
    var n = r.get(t);
    return Object.keys(n).reduce(function (r, t) {
      return r[t] = e[n[t]], r;
    }, Object.create(null));
  }

  return s(t, RegExp), t.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    return t && (t.groups = n(t, this)), t;
  }, t.prototype[Symbol.replace] = function (t, i) {
    if ("string" == typeof i) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, i.replace(/\$<([^>]+)>/g, function (e, r) {
        return "$" + o[r];
      }));
    }

    if ("function" == typeof i) {
      var a = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(n(e, a)), i.apply(this, e);
      });
    }

    return e[Symbol.replace].call(this, t, i);
  }, a.apply(this, arguments);
}

function s(e, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && l(e, r);
}

function l(e, r) {
  return l = Object.setPrototypeOf || function (e, r) {
    return e.__proto__ = r, e;
  }, l(e, r);
}

function u(e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var t = 0, n = new Array(r); t < r; t++) {
    n[t] = e[t];
  }

  return n;
}

function c(e, r) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);

  if (Array.isArray(e) || (t = function (e, r) {
    if (e) {
      if ("string" == typeof e) return u(e, r);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? u(e, r) : void 0;
    }
  }(e)) || r && e && "number" == typeof e.length) {
    t && (e = t);
    var n = 0;
    return function () {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var p = function p(i) {
  return function (o) {
    return void 0 === o && (o = {}), function (r) {
      e(r, "element", s);
    };

    function s(e, s, l) {
      if (l && "pre" === l.tagName && "code" === e.tagName) {
        var u = e.data && e.data.meta ? e.data.meta : "";
        e.properties.className ? "boolean" == typeof e.properties.className ? e.properties.className = [] : Array.isArray(e.properties.className) || (e.properties.className = [e.properties.className]) : e.properties.className = [], e.properties.className.push("code-highlight");

        var p,
            f,
            m = function (e) {
          for (var r, t = c(e.properties.className); !(r = t()).done;) {
            var n = r.value;
            if ("language-" === n.slice(0, 9)) return n.slice(9).toLowerCase();
          }

          return null;
        }(e);

        if (m) try {
          p = i.highlight(r(e), m), l.properties.className = (l.properties.className || []).concat("language-" + m);
        } catch (r) {
          if (!o.ignoreMissing || !/Unknown language/.test(r.message)) throw r;
          p = e;
        } else p = e;
        p.children = (f = 1, function e(r) {
          return r.reduce(function (r, t) {
            if ("text" === t.type) {
              var n = t.value,
                  i = (n.match(/\n/g) || "").length;
              if (0 === i) t.position = {
                start: {
                  line: f,
                  column: 0
                },
                end: {
                  line: f,
                  column: 0
                }
              }, r.push(t);else for (var o, a = n.split("\n"), s = c(a.entries()); !(o = s()).done;) {
                var l = o.value,
                    u = l[0],
                    p = l[1];
                r.push({
                  type: "text",
                  value: u === a.length - 1 ? p : p + "\n",
                  position: {
                    start: {
                      line: f + u
                    },
                    end: {
                      line: f + u
                    }
                  }
                });
              }
              return f += i, r;
            }

            if (Object.prototype.hasOwnProperty.call(t, "children")) {
              var m = f;
              return t.children = e(t.children), r.push(t), t.position = {
                start: {
                  line: m,
                  column: 0
                },
                end: {
                  line: f,
                  column: 0
                }
              }, r;
            }

            return r.push(t), r;
          }, []);
        })(p.children), p.position = p.children.length > 0 ? {
          start: {
            line: p.children[0].position.start.line,
            column: 0
          },
          end: {
            line: p.children[p.children.length - 1].position.end.line,
            column: 0
          }
        } : {
          start: {
            line: 0,
            column: 0
          },
          end: {
            line: 0,
            column: 0
          }
        };

        for (var h, d = function (e) {
          var r = /{([\d,-]+)}/,
              t = e.split(",").map(function (e) {
            return e.trim();
          }).join();

          if (r.test(t)) {
            var i = r.exec(t)[1],
                o = n(i);
            return function (e) {
              return o.includes(e + 1);
            };
          }

          return function () {
            return !1;
          };
        }(u), g = function (e) {
          var r = /*#__PURE__*/a(/showLineNumbers=([0-9]+)/i, {
            lines: 1
          });

          if (r.test(e)) {
            var t = r.exec(e);
            return Number(t.groups.lines);
          }

          return 1;
        }(u), y = function (e) {
          for (var r = new Array(e), t = 0; t < e; t++) {
            r[t] = {
              type: "element",
              tagName: "span",
              properties: {
                className: []
              },
              children: []
            };
          }

          return r;
        }(p.position.end.line), v = ["showlinenumbers=false", 'showlinenumbers="false"', "showlinenumbers={false}"], b = function b() {
          var e = h.value,
              n = e[0],
              i = e[1];
          i.properties.className = ["code-line"];
          var a = t(p, function (e) {
            return e.position.start.line <= n + 1 && e.position.end.line >= n + 1;
          });
          i.children = a.children, !u.toLowerCase().includes("showLineNumbers".toLowerCase()) && !o.showLineNumbers || v.some(function (e) {
            return u.toLowerCase().includes(e);
          }) || (i.properties.line = [(n + g).toString()], i.properties.className.push("line-number")), d(n) && i.properties.className.push("highlight-line"), "diff" === m && "-" === r(i).substring(0, 1) ? i.properties.className.push("deleted") : "diff" === m && "+" === r(i).substring(0, 1) && i.properties.className.push("inserted");
        }, w = c(y.entries()); !(h = w()).done;) {
          b();
        }

        y.length > 0 && "" === r(y[y.length - 1]).trim() && y.pop(), e.children = y;
      }
    }
  };
},
    f = p(i),
    m = p(o);

export { m as default, f as rehypePrismCommon, p as rehypePrismGenerator };